
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/region",
      function () {
        return require("private-next-pages/region.tsx");
      }
    ]);
  